import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { SimpleThree } from './SimpleThree';

interface ScrollHeroProps {
  modelUrl?: string;
}

export const ScrollHero: React.FC<ScrollHeroProps> = ({ modelUrl }) => {
  return (
    <section className="relative min-h-screen flex flex-col overflow-hidden bg-foreground">
      {/* 3D Background */}
      <SimpleThree modelUrl={modelUrl} />

      {/* Light gradient overlay for text readability on dark hero */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent z-10" />

      {/* Hero Content */}
      <div className="relative z-20 container mx-auto px-4 flex-1 flex items-end pb-16 md:pb-24">
        <div className="max-w-2xl">
          <p className="text-xs md:text-sm font-semibold tracking-[0.3em] uppercase text-white/70 mb-4 font-orbit">
            Forskningsbasert · Klinisk dosert
          </p>

          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-orbit font-black text-white leading-[0.95] mb-6">
            NORGES HØYEST
            <br />
            DOSERTE
            <br />
            <span className="text-primary">PRE-WORKOUT</span>
          </h1>

          <p className="text-base md:text-lg text-white/70 max-w-md mb-8 leading-relaxed">
            10 000 mg L-Citrulline per porsjon — nesten 3× markedsstandard.
            Ingen fyllstoffer, ingen proprietary blends.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              size="lg"
              className="px-8 py-6 text-base font-bold tracking-wide transition-all duration-200 hover:scale-[1.03] active:scale-[0.98]"
              onClick={() => {
                const el = document.getElementById('products');
                el?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Se produkter
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="px-8 py-6 text-base font-bold tracking-wide border-white/30 text-white hover:bg-white/10 transition-all duration-200"
              onClick={() => {
                const el = document.getElementById('why-choose-peveo');
                el?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Hvorfor Peveo?
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2 opacity-60">
        <span className="text-[10px] tracking-[0.25em] uppercase text-white/50 font-orbit">Scroll</span>
        <div className="w-px h-8 bg-gradient-to-b from-white/40 to-transparent" />
      </div>
    </section>
  );
};
